{
    "Accessibility menu": "Accessibility menu",
    "Close": "Close",
    "Content adjustments": "Content adjustments",
    "Navigation adjustments": "Navigation adjustments",
    "Text Align": "Text Align",
    "Align Left": "Align Left",
    "Align Center": "Align Center",
    "Align Right": "Align Right",
    "Adjust Font Size": "Adjust Font Size",
    "Highlight Title": "Highlight Title",
    "Highlight Links": "Highlight Links",
    "Readable Font": "Readable Font",
    "Colour adjustments": "Colour adjustments",
    "Dark Contrast": "Dark Contrast",
    "Light Contrast": "Light Contrast",
    "High Contrast": "High Contrast",
    "High Saturation": "High Saturation",
    "Low Saturation": "Low Saturation",
    "Monochrome": "Monochrome",
    "Tools": "Tools",
    "Reading Guide": "Reading Guide",
    "Big Cursor": "Big Cursor",
    "Increase Font Size": "Increase Font Size",
    "Decrease Font Size": "Decrease Font Size",
    "Letter Spacing": "Letter Spacing",
    "Line Height": "Line Height",
    "Font Weight": "Font Weight",
    "Dyslexia Font": "Dyslexia Font",
    "Language": "Language",
    "Accessibility widget": "Accessibility widget",
    "Accessibility Profiles": "Accessibility Profiles",
    "Cognitive Disability": "Cognitive Disability",
    "Seizure Safe": "Seizure Safe",
    "Accessibility statement": "Accessibility statement",
    "ADHD": "ADHD",
    "Low Vision": "Low Vision",
    "Pause Animations": "Pause Animations",
    "Animation paused": "Animation paused",
    "Reset all settings": "Reset all settings",
    "Shortcut:": "Shortcut:",
    "Epilepsy Safe Mode": "Epilepsy Safe Mode",
    "Mute sounds": "Mute sounds",
    "Page read": "Page read",
    "Page read controls": "Page read controls",
    "Pause": "Pause",
    "Resume": "Resume",
    "Stop": "Stop",
    "Settings": "Settings",
    "Speed": "Speed",
    "Voice": "Voice"
}
